export default __webpack_public_path__ + "static/media/news-detail.6a0b545f.png";